import { useTranslation } from 'react-i18next'
import { AlertCircle, RotateCw } from 'lucide-react'
import { Button } from '@/components/ui/button'
import type { Message } from '@/types/conversations'

interface ProcessingErrorMessageProps {
  message: Message
  onRetry?: () => void
  isProcessing?: boolean
}

export function ProcessingErrorMessage({ message, onRetry, isProcessing = false }: ProcessingErrorMessageProps) {
  const { t } = useTranslation('conversations')

  return (
    <div className="mt-4 animate-in fade-in duration-300">
      <div className="pl-4 py-3 border-l-2 border-red-400/60 dark:border-red-500/40 bg-red-50/40 dark:bg-red-950/20 rounded-r-lg">
        <div className="flex items-start gap-2 text-sm text-foreground">
          <AlertCircle className="h-4 w-4 text-destructive shrink-0 mt-0.5" />
          <span>{message.content || t('chat.processingError')}</span>
        </div>
        {onRetry && (
          <Button
            variant="outline"
            size="sm"
            onClick={onRetry}
            disabled={isProcessing}
            className="mt-2 ml-6 gap-1.5 text-xs"
          >
            <RotateCw className={`h-3 w-3 ${isProcessing ? 'animate-spin' : ''}`} />
            {t('chat.retry')}
          </Button>
        )}
      </div>
    </div>
  )
}
